

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// PurchaseSchemes
// PURCHASESCHEMES
const PURCHASESCHEMES= createAsyncThunk(
  "PurchaseSchemes/PurchaseSchemes",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const PurchaseSchemesSlice = createSlice({
  name: "PurchaseSchemesSlice",
  initialState: {
    PurchaseSchemes: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfPurchaseSchemes: (state) => {
        state.PurchaseSchemes.loading = false
        state.PurchaseSchemes.error = false
        state.PurchaseSchemes.data = []
        state.PurchaseSchemes.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(PURCHASESCHEMES.fulfilled, (state, action) => {
      state.PurchaseSchemes = {
        ...state.PurchaseSchemes,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(PURCHASESCHEMES.pending, (state, action) => {
      state.PurchaseSchemes = {
        ...state.PurchaseSchemes,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(PURCHASESCHEMES.rejected, (state, action) => {
      state.PurchaseSchemes = {
        ...state.PurchaseSchemes,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const PurchaseSchemesAction = {
    PURCHASESCHEMES,
};

export { PurchaseSchemesAction };
export default PurchaseSchemesSlice.reducer;
export const {setInitialStateOfPurchaseSchemes} = PurchaseSchemesSlice.actions